<script>
    // @ts-nocheck
    import Menu from '$lib/components/layout/Menu2.svelte'
    import FrameUI from '$lib/components/layout/FrameUI.svelte'
    import { setContext } from 'svelte'
    import bg from '../assets/pictures/art-bg.svg'
    import { Router, Route, navigate, useFocus } from 'svelte-navigator'
    import { formatCUIT } from '$lib/utils'
    import toast, { Toaster } from 'svelte-french-toast'
    import { fly } from 'svelte/transition'
    import Content from '$lib/components/layout/Content.svelte'
    import { onMount, onDestroy } from 'svelte'
    import PrivateRoute from '$lib/components/layout/PrivateRoute.svelte'
    import Profile from './Profile.svelte'
    import Facturas from './Facturas.svelte'
    import MisOfertasMain from './MisOfertasMain.svelte'
    import FacturasSiniestro from './FacturasSiniestro.svelte'
    import Empleados from './Empleados.svelte'
    import Comprobantes from './Comprobantes.svelte'
    import PreguntasFrecuentes from './PreguntasFrecuentes.svelte'
    import Sucursales from './Sucursales.svelte'
    import Licitaciones from './Licitaciones.svelte'
    import user from '$lib/stores/user'
    import provider from '$lib/stores/provider'
    import Documentacion from './Documentacion.svelte'
    import {
        BackDrop,
        Modal,
        Button,
        TertiaryButton,
        Typography,
        Link,
    } from '$lib/components/UI/'
    import { ChevronDown } from '$lib/components/Icons'
    // import { offers, initialization as destroyOfferStore } from '$lib/services/collections/offers'
    // import { tenders, destroy as destroyTenderstore } from '$lib/services/collections/tenders'
    import {
        invoices as invoices_sin,
        initialization as createSyncInvoices,
    } from '$lib/services/collections/invoices_sin'
    import {
        offers as ofertas,
        // fixAsserts,
        // fixCallback,
        initialization as createSyncOffers,
    } from '$lib/services/collections/offers'
    import {
        tenders,
        initialization as createSyncTenders,
    } from '$lib/services/collections/tenders'
    import Testing from './Testing.svelte'
    import MisReclamos from './MisReclamos.svelte'
    import MisOfertas from './MisOfertas.svelte'
    import MantainanceAlertInfo from '$lib/custom/components/MantainanceAlertInfo.svelte'
    const focus = useFocus()
    let isOpen = false
    let routes = [
        { label: 'Home', path: '/home' },
        { label: 'Mis Facturas', path: '/home/invoices' },
        {
            label: 'Licitaciones',
            path: '/home/licitaciones',
            tipo_proveedor: ['siniestros'],
        },
        {
            label: 'Mis Ofertas',
            path: '/home/ofertas',
            tipo_proveedor: ['siniestros'],
        },
        // { label: 'Mis Comprobantes', path: '/home/vouchers' },
        {
            label: 'Mis Sucursales',
            path: '/home/sucursales',
            tipo_proveedor: ['siniestros'],
        },
        {
            label: 'Mis Empleados',
            path: '/home/employes',
            // tipo_proveedor: ['general'],
        },
        { label: 'Perfil', path: '/home/profile' },
        { label: 'Documentación', path: '/home/documents' },
        { label: 'Preguntas frecuentes', path: '/home/faqs' },
    ].filter((route) =>
        route?.tipo_proveedor
            ? route.tipo_proveedor.includes($user?.tipo_proveedor)
            : true
    )

    let links = [
        // {
        //     label: 'Datos impositivos',
        //     link: 'https://seguros.lacaja.com.ar/quienes-somos/datos-impositivos',
        // },
        // { label: 'Cobranzas.com', link: 'https://www.cobranzas.com/' },
        // {label: 'Subir factura', link: ENV.PUBLIC_URL}
    ]

    let homeItems = [
        {
            title: 'Licitaciones',
            desc: 'Acá podes participar de las licitaciones.',
            label: 'Licitaciones',
            path: '/home/licitaciones',
            tipo_proveedor: ['siniestros'],
        },
        {
            title: 'Sucursales',
            desc: 'Acá podes gestionar de tus sucursales.',
            label: 'Sucursales',
            path: '/home/sucursales',
            tipo_proveedor: ['siniestros'],
        },
        {
            title: 'Mis Facturas',
            desc: 'Acá podes gestionar las facturas de tu empresa.',
            label: 'Facturas',
            path: '/home/invoices',
        },
        // {
        //     title: 'Mis Comprobantes',
        //     desc: 'Acá podes consultar los comprobantes de transferencia y retención de tu empresa.',
        //     label: 'Comprobantes',
        //     path: '/home/vouchers',
        // },
        {
            title: 'Documentación',
            desc: 'Acá podes gestionar la documentación de tu empresa.',
            label: 'Documentos',
            path: '/home/documents',
        },
        {
            title: 'Datos de la Empresa',
            desc: 'Acá podes gestionar los datos de tu empresa.',
            label: 'Perfil',
            path: '/home/profile',
        },
    ].filter((item) =>
        item?.tipo_proveedor
            ? item.tipo_proveedor.includes($user?.tipo_proveedor)
            : true
    )

    let modalOpen = $user?.firstLogin && $user?.preloaded
    let modalClaims =
        $user?.pendingClaims?.length > 0 &&
        $provider?.data?.tipo_proveedor_ii == '4'
    let currentProvider = {}
    let [invoicesSyncInterval, destroyInvoiceSinstore] =
        $user?.tipo_proveedor == 'siniestros'
            ? createSyncInvoices()
            : [0, () => {}]
    let [offersSyncInterval, destroyOfferStore] =
        $user?.tipo_proveedor == 'siniestros'
            ? createSyncOffers()
            : [0, () => {}]
    let [tendersSyncInterval, destroyTenderstore] =
        $user?.tipo_proveedor == 'siniestros'
            ? createSyncTenders()
            : [0, () => {}]
    // let fixOffersInterval = setInterval(() => {
    //     if($user?.tipo_proveedor == 'siniestros') ofertas.fixEntries(fixAsserts, fixCallback)
    // }, 15000)
    onMount((_) => {
        currentProvider = $user?.accounts[user.currentAccount]
        invoicesSyncInterval
        offersSyncInterval
        tendersSyncInterval
        provider.load()
        return () => {
            // clearInterval(fixOffersInterval)
            destroyOfferStore()
            destroyTenderstore()
            destroyInvoiceSinstore()
        }
    })
    $: console.log({'invoices_sin_': $invoices_sin})
    setContext('toast', toast)
</script>

<svelte:head>
    <!-- <meta name="viewport" content="width=device-width, initial-scale=0.9" /> -->
    <!-- <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" /> -->
    <meta
        name="viewport"
        content="height=device-height, initial-scale=1, maximum-scale=1, user-scalable=no" />
</svelte:head>
<svelte:window
    on:beforeunload={() => {
        let token = user.token
        if ($user && token) {
            window.localStorage.setItem(
                'UserData',
                JSON.stringify({ ...$user, token })
            ) // Save user data
        }
    }} />
<Toaster
    position="top-center"
    containerStyle="position:fixed; z-index: var(--lvl-5)" 
/>
<!-- <MantainanceAlertInfo></MantainanceAlertInfo> -->
<PrivateRoute>
    <FrameUI
        background="grey"
        bind:isOpen
        on:clicklogo={(_) => navigate('/home')}>
        <svelte:fragment slot="sideMenu">
            <Menu options={routes} {links} {user} bind:isOpen />
        </svelte:fragment>
        <svelte:fragment slot="leftSpace">
            <span class="cuitSelector">
                CUIT | {formatCUIT($user?.defaultAccount || '')}
                <ChevronDown color="#FFFFFF" /></span>
        </svelte:fragment>
        <!-- <Content breakPoint="1920px"> -->
        <Content breakPoint="100%">
            <Router primary={false}>
                <!-- {#if $location?.path && $location.path.match(/invoices/)} -->
                <!-- {/if} -->
                <Route path="/">
                    <!-- <span use:focus/> -->
                    <div use:focus class="banner">
                        <Typography
                            color="white"
                            style="margin:0; padding:0"
                            type="h3"
                            >Hola, {$user?.fullName} | {currentProvider?.name}
                            {user.currentAccount}</Typography>
                        {#if !($provider?.editable || false)}
                            <Link
                                href="/home/profile"
                                style="color: white; foont-size: 15px"
                                >Solicitud de modificación en curso</Link>
                        {:else}
                            <Typography
                                color="white"
                                style="margin:0; padding:0"
                                type="body">
                                Seleccioná un acceso rápido y comenzá a operar.
                            </Typography>
                        {/if}
                    </div>
                    <div
                        style="padding: 0 70px;align-items: center;gap: 52px;min-height: calc(100vh - 70px); display: flex; position: relative; flex-direction: column">
                        {#each homeItems as { title, desc, path, label }, i}
                            <div
                                in:fly={{
                                    y: 25,
                                    x: 25,
                                    duration: 200,
                                    delay: 200 + i * 50,
                                }}
                                style="background-image: url({bg});"
                                class="item">
                                <span>
                                    <Typography
                                        style="margin: 0;padding: 0"
                                        type="h3">{title}</Typography>
                                    <Typography
                                        style="margin: 0;padding: 0"
                                        type="body">{desc}</Typography>
                                    <i>
                                        <TertiaryButton
                                            disabled={path === '/home'}
                                            on:click={(_) => navigate(path)}
                                            label={`Ir a ${label}`} />
                                    </i>
                                </span>
                            </div>
                        {/each}
                    </div>
                    <BackDrop visible={modalOpen}>
                        <Modal
                            closeable={false}
                            title="Revision de la información">
                            <Typography type="body">
                                Por favor revise que la información cargada sea
                                correcta. En caso de encontrar una
                                inconsistencia, solicite una modificación a la
                                brevedad.
                            </Typography>
                            <Button
                                label="Revisar"
                                on:click={(_) => {
                                    modalOpen = false
                                    navigate('/home/profile', {})
                                }} />
                        </Modal>
                    </BackDrop>
                    <BackDrop visible={modalClaims} style="position:fixed">
                        <Modal
                            title="Revisión de reclamos"
                            on:clickout={() => (modalClaims = false)}
                            on:close={() => (modalClaims = false)}>
                            <Typography type="body">
                                Por favor revise sus reclamos pendientes. Tiene <strong
                                    >{$user.pendingClaims.length}</strong>
                                sin responder.
                                <!-- {JSON.stringify($user.pendingClaims, null, 4)} -->
                            </Typography>
                            <svelte:fragment slot="buttonSet">
                                <Button
                                    label="Ir a reclamos"
                                    on:click={(_) => {
                                        modalClaims = false
                                        navigate(
                                            '/home/licitaciones/mis-reclamos',
                                            {}
                                        )
                                    }} />
                            </svelte:fragment>
                        </Modal>
                    </BackDrop>
                </Route>
                <Route path="/profile" component={Profile} />
                <Route path="/documents" component={Documentacion} />
                <Route path="/employes" component={Empleados} />
                <Route path="/sucursales" component={Sucursales} />
                <Route path="/testing" component={Testing} />
                {#key $user?.tipo_proveedor}
                    <Route
                        path="/invoices/*"
                        component={$user?.tipo_proveedor == 'siniestros' ? FacturasSiniestro : Facturas}
                        />
                {/key}
                <Route path="/licitaciones/*" component={Licitaciones} />
                <Route path="/ofertas/*" component={MisOfertasMain} />
                <Route path="/vouchers/*" component={Comprobantes} />
                <Route path="/faqs" component={PreguntasFrecuentes} />
            </Router>
        </Content>
    </FrameUI>
</PrivateRoute>

<style>
    .item {
        border-radius: 9px;
        width: 100%;
        background-color: var(--color-white);
        padding: 30px 45px;
        user-select: none;
        /* background-image: url({bg}); */
        background-size: 300px;
        background-position: right center;
        background-repeat: no-repeat;
        box-shadow: var(--shadow-default);
    }
    .item span {
        display: flex;
        gap: 16px;
        flex-direction: column;
    }
    .item span i {
        margin: 10px 0 0 0;
        align-self: flex-end;
    }
    .banner {
        width: 100%;
        position: relative;
        background-color: var(--color-accent-01);
        display: flex;
        padding: 22px 70px;
        margin: 0 0 52px 0;
        flex-direction: column;
    }

    .cuitSelector {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 24px;
        gap: 14px;
        height: 40px;
        border: 1px solid #ffffff;
        border-radius: 1000px;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 22px;
        color: #ffffff;
        user-select: none;
        cursor: no-drop;
    }
</style>
